var lib_core = require("lib-core");

var ToolbarModel = function () {
    lib_core.Model.apply(this);

    this.activeTool = this.value("activeTool", true);
    this.activeTool("select");

    this.modes = new lib_core.Collections.List();
    this.activeMode = this.value("activeMode", true);
};
lib_core.inherit(ToolbarModel, lib_core.Model);
lib_core.JsonParser.registerClass(ToolbarModel, "ToolbarModel");

module.exports = ToolbarModel;
